import { FunctionComponent } from "react"
import GlobalStyles from "components/Global.styles"
import { CssBaseline } from "@mui/material"
import { Provider as StoreProvider } from "react-redux"
import type { AppStore } from "@client-hub/store/createStore"
import Notifier from "components/Notifier"
import { Persistor } from "redux-persist"
import { PersistGate } from "redux-persist/integration/react"
import ThemeProvider from "components/ThemeProvider"
import Telemetry, { LogProvider } from "components/Telemetry"
import { SnackbarProvider } from "@icanbwell/ui-toolkit"
import { routeMap } from "routeMap"
import { useRoutes } from "react-router"
import { AnalyticsProvider } from "@client-hub/shared/react/components/AnalyticsProvider"

type Props = {
  store: AppStore
  persistor: Persistor
}

const App: FunctionComponent<Props> = ({ store, persistor }) => {
  const element = useRoutes(routeMap)
  return (
    <LogProvider>
      <StoreProvider store={store}>
        <AnalyticsProvider>
          <ThemeProvider>
            <GlobalStyles />
            <CssBaseline />
            <Telemetry />
            <SnackbarProvider>
              <Notifier />
              <PersistGate loading={null} persistor={persistor}>
                {element}
              </PersistGate>
            </SnackbarProvider>
          </ThemeProvider>
        </AnalyticsProvider>
      </StoreProvider>
    </LogProvider>
  )
}

export default App
